<template>
  <div id="app">
    <Nav />
    <router-view :key="$route.fullPath"></router-view>
    <Footer />
  </div>
</template>

<script>
import Nav from "./components/Nav.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: { Nav, Footer },
  computed: {
    localeInstance() {
      return this.$i18n.locale;
    }
  },
  watch: {
    localeInstance: function(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.$i18n.locale = newValue;
      localStorage.locale = newValue;
    }
  },
  mounted() {
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      this.$i18n.locale = "en";
    }
  }
};
</script>

<style lang="css">
a {
  text-decoration: none;
}

h1 {
  font-size: 120px;
  font-weight: bold;
}

#category {
  font-family: Staatliches;
  font-weight: 500;
}

#title {
  letter-spacing: 0.4px;
  font-size: 22px;
  font-size: 1.375rem;
  line-height: 1.13636;
}

#banner {
  margin: 20px;
  height: 800px;
}

#editor {
  font-size: 16px;
  font-size: 1rem;
  line-height: 1.75;
}

.uk-navbar-container {
  background: #fff !important;
  font-family: Staatliches;
}

img:hover {
  opacity: 1;
  transition: opacity 0.25s cubic-bezier(0.39, 0.575, 0.565, 1);
}

* {
  font-family: "Nunito", sans-serif;
}
</style>
